import { GlareProps } from './types';

export const defaultGlareProps: GlareProps = {
  glareEnable: false,
  glareMaxOpacity: 0.7,
  glareColor: '#ffffff',
  glarePosition: 'bottom',
  glareReverse: false,
};
